module.exports = __webpack_public_path__ + "img/case3.7dad7c62.png";